<form [formGroup]="panFormGroup" (ngSubmit)="onSubmit(panFormGroup)">
  <mat-form-field class="input-field">
    <input #pan matInput type="text" placeholder="Name as on PAN card" formControlName="name" maxlength="50" [readonly]="isPanVerified"/>
    <span *ngIf="pan.readOnly" (click)="clearPanInfo()" id="user">Try different user?</span>
    <mat-error>{{ getErrorMessage(panFormGroup.controls.name) }}</mat-error>
  </mat-form-field>


  <div class="grey-section px-5 py-3 mb-3 mt-2" *ngIf="isPanNameNotMatched(panFormGroup.controls.name)">
    <p>A name mismatch issue may be resolved by entering your name in its full form.</p>
    <p>For example:<br>
      <span class="glyphicon glyphicon-remove-circle pr-1"></span>If your PAN has <b>Rahul K S</b>.<br>
      <span class="glyphicon glyphicon-ok-circle pr-1"></span> Please enter the full form - <b>Rahul Kumar
        Singh</b> and
      try again
    </p>
    <p class="m-0">If you continue facing an issue verifying your PAN, please write to us at
      <span class="text-color-finzy-blue">support@finzy.com</span></p>
  </div>

  <mat-form-field class="input-field">
    <input matInput class="pan" type="text" maxlength="10" placeholder="Eg : ASDFG4567H" formControlName="pan" [readonly]="isPanVerified"/>
    <button mat-stroked-button matSuffix class="btn-input-suffix" (click)="analyticsTracker.trackButtonClick('Pan Verification', 'Verify')" type="submit"
    *ngIf="!shouldShowLoader && !isPanVerified">VERIFY</button>
    <i matSuffix class="fa fa-check tick-input-suffix" aria-hidden="true" *ngIf="isPanVerified"></i>
    <mat-error>{{ getErrorMessage(panFormGroup.controls.pan) }}</mat-error>
    <mat-spinner [diameter]="35" matSuffix *ngIf="shouldShowLoader"></mat-spinner>
  </mat-form-field>
</form>
